<cars-equation
  *ngIf="content?.unitEquationSource?.length"
  (click)="openSidebar()"
  [source]="content.unitEquationSource"
  [inline]="true"
></cars-equation>
<span *ngIf="!content?.unitEquationSource?.length" (click)="openSidebar()" contenteditable="false">{{
  content.displayPlaceholder
}}</span>
